import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    today: '',
    datesSet: {},
    windowInnerWidth: null,
    mobileBreakpoint: 900,
    resetToCalendarView: false,
    calendarView: false,
    locked: false,
    showSpinner: false,
    initial: true,
    searchTerm: '',
    autocompleteTerm: '',
    fullResponse: {},
    resultsItems: [],
    calendarResultsItems: [],
    resultsData: {},
    autocompleteResultsItems: [],
    autocompleteResultsData: {},
    facets: {},
    activeFilters: [],
    allTypeFilters: [],
    allIssueFilters: [],
    allGroupOneFilters: [],
    allArticleTypeFilters: [],
    allResourceTypeFilters: [],
    allCampaignFilters: [],
    allGroupTwoFilters: [],
    allRoleFilters: [],
    allYearFilters: [],
    allStateFilters: [],
    allProfessionalPracticeFilters: [],
    allFormatFilters: [],
    allAcademicSubjectFilters: [],
    allGradeLevelFilters: [],
    allNEATodayFilters: [],

    allThemeFilters: [],
    allReadingLevelFilters: [],
    allGenreFilters: [],

    allActionTypeFilters: [],
    allCongressFilters: [],
    allPositionFilters: [],
    allChamberFilters: [],
    allQuickActionFilters: [],
    allFederalLegislationIssueFilters: [],
    allEventTypeFilters: [],
    allRegionFilters: [],
    allShowPastEventsFilters: [],

    allBusinessItemTypeFilters: [],
    allOutcomeFilters: [],
    allStrategicObjectiveFilters: [],

    allNEATodaySectionFilters: [],

    currentPage: 1,
    perPage: 10,
    perPageList: 10,
    perPageCalendar: 100,
    newTypeCount: null,
    newGroupOneCount: null,
    newGroupTwoCount: null,
    newArticleTypeCount: null,
    newResourceTypeCount: null,
    newCampaignCount: null,
    newAcademicSubjectCount: null,
    newGradeLevelCount: null,
    newRoleCount: null,
    newYearCount: null,
    newIssueCount: null,
    newStateCount: null,
    newNEATodayCount: null,
    newProfessionalPracticeCount: null,
    newFormatCount: null,

    newThemeCount: null,
    newReadingLevelCount: null,
    newGenreCount: null,

    newActionTypeCount: null,
    newCongressCount: null,
    newPositionCount: null,
    newChamberCount: null,
    newQuickActionCount: null,
    newFederalLegislationIssueCount: null,
    newEventTypeCount: null,
    newRegionCount: null,
    newShowPastEventsCount: null,

    newBusinessItemTypeCount: null,
    newOutcomeCount: null,
    newStrategicObjectiveCount: null,

    newNEATodaySectionCount: null,

    raYear: null,

    additionalParameters: [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'ms'
    ],

    pageIntro: {
      search: {
        title: 'Search',
        summary: 'Type a phrase in the search box or use the filters below to start browsing our articles and resources.'
      },
      resource_library: {
        title: 'Resource Library',
        summary: 'Whether you\'re focused on your classroom, community, or  capitol, we have tools to help you transform teaching and learning.'
      },
      new_from_nea: {
        title: 'New From NEA',
        summary: 'Read the latest on our advocacy, our members, and the education trends we\'re watching.'
      },
      professional_learning_resources: {
        title: 'Professional Learning Resources',
        summary: '<p>From our affiliates to yours, workshops, webinars, and blended learning opportunities to support NEA members throughout their careers.</p>'
          + '<p>Looking for advice articles, podcasts, or other tools for educators? Visit our <a href="/resource-library">Resource Library</a>.</p>'
      },
      federal_education_funding: {
        title: 'Federal Education Funding',
        summary: '<p>Browse federal education grants by issue, professional practice, and more as you advocate for great public schools for all students.</p>'
      },
      find_your_book: {
        title: 'Find Your Book',
        summary: 'Inspire and engage your students with books that reflect their experiences and expand their horizons.'
      },
      take_action: {
        title: 'Take Action',
        summary: 'We need to dismantle unjust systems. We need to fully fund public schools. We need to hold our elected leaders accountable to our communities. And we need your help to make it happen.'
      },
      letters_and_testimony: {
        title: 'Letters & Testimony',
        summary: 'NEA speaks up for the rights of students. Browse recent messages to Congressional leadership, and add your voice.'
      },
      bills: {
        title: 'Bills',
        summary: 'Learn NEA\'s position on pending legislation related to public education, and take action to protect our schools.'
      },
      ra_agenda: {
        title: 'RA Agenda',
        summary: 'Browse the list to explore all events, or find specific events by state, type, or keyword search.'
      },
      ra_calendar: {
        title: 'Calendar of Events',
        summary: 'Browse the list to explore all events, or find specific events by state, type, or keyword search.'
      }
    },
    openDropdown: null,
    isAuthenticated: false,
    nextUrl: null,
  },
  getters: {
    getToday: state => {
      return state.today
    },
    getDatesSet: state => {
      return state.datesSet
    },
    getWindowInnerWidth: state => {
      return state.windowInnerWidth
    },
    getMobileBreakpoint: state => {
      return state.mobileBreakpoint
    },
    getResetToCalendarView: state => {
      return state.resetToCalendarView
    },
    getCalendarView: state => {
      return state.calendarView
    },
    getSearchTerm: state => {
      return state.searchTerm
    },
    getAutocompleteTerm: state => {
      return state.autocompleteTerm
    },
    getCurrentPage: state => {
      return state.currentPage
    },
    getPerPage: state => {
      return state.perPage
    },
    getPerPageCalendar: state => {
      return state.perPageCalendar
    },
    getPerPageList: state => {
      return state.perPageList
    },
    getLocked: state => {
      return state.locked
    },
    getShowSpinner: state => {
      return state.showSpinner
    },
    getInitial: state => {
      return state.initial
    },
    getFullResponse: state => {
      return state.fullResponse
    },
    getResultsItems: state => {
      return state.resultsItems
    },
    getResultsData: state => {
      return state.resultsData
    },
    getCalendarResultsItems: state => {
      return state.calendarResultsItems
    },
    getAutocompleteResultsItems: state => {
      return state.autocompleteResultsItems
    },
    getAutocompleteResultsData: state => {
      return state.autocompleteResultsData
    },
    getAllTypeFilters: state => {
      return state.allTypeFilters
    },
    getAllIssueFilters: state => {
      return state.allIssueFilters
    },
    getAllGroupOneFilters: state => {
      return state.allGroupOneFilters
    },
    getAllGroupTwoFilters: state => {
      return state.allGroupTwoFilters
    },
    getAllArticleTypeFilters: state => {
      return state.allArticleTypeFilters
    },
    getAllResourceTypeFilters: state => {
      return state.allResourceTypeFilters
    },
    getAllRoleFilters: state => {
      return state.allRoleFilters
    },
    getAllYearFilters: state => {
      return state.allYearFilters
    },
    getAllCampaignFilters: state => {
      return state.allCampaignFilters
    },
    getAllStateFilters: state => {
      return state.allStateFilters
    },
    getAllProfessionalPracticeFilters: state => {
      return state.allProfessionalPracticeFilters
    },
    getAllFormatFilters: state => {
      return state.allFormatFilters
    },
    getAllAcademicSubjectFilters: state => {
      return state.allAcademicSubjectFilters
    },
    getAllGradeLevelFilters: state => {
      return state.allGradeLevelFilters
    },
    getAllNEATodayFilters: state => {
      return state.allNEATodayFilters
    },

    getAllThemeFilters: state => {
      return state.allThemeFilters
    },
    getAllReadingLevelFilters: state => {
      return state.allReadingLevelFilters
    },
    getAllGenreFilters: state => {
      return state.allGenreFilters
    },

    getAllActionTypeFilters: state => {
      return state.allActionTypeFilters
    },
    getAllCongressFilters: state => {
      return state.allCongressFilters
    },
    getAllPositionFilters: state => {
      return state.allPositionFilters
    },
    getAllChamberFilters: state => {
      return state.allChamberFilters
    },
    getAllQuickActionFilters: state => {
      return state.allQuickActionFilters
    },
    getAllFederalLegislationIssueFilters: state => {
      return state.allFederalLegislationIssueFilters
    },
    getAllEventTypeFilters: state => {
      return state.allEventTypeFilters
    },
    getAllRegionFilters: state => {
      return state.allRegionFilters
    },
    getAllShowPastEventsFilters: state => {
      return state.allShowPastEventsFilters
    },

    getAllBusinessItemTypeFilters: state => {
      return state.allBusinessItemTypeFilters
    },
    getAllOutcomeFilters: state => {
      return state.allOutcomeFilters
    },
    getAllStrategicObjectiveFilters: state => {
      return state.allStrategicObjectiveFilters
    },

    getAllNEATodaySectionFilters: state => {
      return state.allNEATodaySectionFilters
    },
    getRaYear: state => {
      return state.raYear
    },

    getActiveFilters: state => {
      return state.activeFilters
    },
    getFacets: state => {
      return state.facets
    },
    getNewTypeCount: state => {
      return state.newTypeCount
    },
    getNewArticleTypeCount: state => {
      return state.newArticleTypeCount
    },
    getNewGroupOneCount: state => {
      return state.newGroupOneCount
    },
    getNewGroupTwoCount: state => {
      return state.newGroupTwoCount
    },
    getNewResourceTypeCount: state => {
      return state.newResourceTypeCount
    },
    getNewCampaignCount: state => {
      return state.newCampaignCount
    },
    getNewRoleCount: state => {
      return state.newRoleCount
    },
    getNewYearCount: state => {
      return state.newYearCount
    },
    getNewIssueCount: state => {
      return state.newIssueCount
    },
    getNewStateCount: state => {
      return state.newStateCount
    },
    getNewNEATodayCount: state => {
      return state.newNEATodayCount
    },
    getNewProfessionalPracticeCount: state => {
      return state.newProfessionalPracticeCount
    },
    getNewFormatCount: state => {
      return state.newFormatCount
    },
    getNewAcademicSubjectCount: state => {
      return state.newAcademicSubjectCount
    },
    getNewGradeLevelCount: state => {
      return state.newGradeLevelCount
    },

    getNewThemeCount: state => {
      return state.newThemeCount
    },
    getNewReadingLevelCount: state => {
      return state.newReadingLevelCount
    },
    getNewGenreCount: state => {
      return state.newGenreCount
    },

    getNewActionTypeCount: state => {
      return state.newActionTypeCount
    },
    getNewCongressCount: state => {
      return state.newCongressCount
    },
    getNewPositionCount: state => {
      return state.newPositionCount
    },
    getNewChamberCount: state => {
      return state.newChamberCount
    },
    getNewQuickActionCount: state => {
      return state.newQuickActionCount
    },
    getNewFederalLegislationIssueCount: state => {
      return state.newFederalLegislationIssueCount
    },
    getNewEventTypeCount: state => {
      return state.newEventTypeCount
    },
    getNewRegionCount: state => {
      return state.newRegionCount
    },

    getNewBusinessItemTypeCount: state => {
      return state.newBusinessItemTypeCount
    },
    getNewOutcomeCount: state => {
      return state.newOutcomeCount
    },
    getNewStrategicObjectiveCount: state => {
      return state.newStrategicObjectiveCount
    },

    getNewNEATodaySectionCount: state => {
      return state.newNEATodaySectionCount
    },

    getPageIntro: state => {
      return state.pageIntro
    },
    getOpenDropdown: state => {
      return state.openDropdown
    },
    getIsAuthenticated: state => {
      return state.isAuthenticated
    },
    getNextUrl: state => {
      return state.nextUrl
    },

    getAdditionalParameters: state => {
      return state.additionalParameters
    },
  },
  mutations: {
    updateToday(state, newState) {
      state.today = newState;
    },
    updateDatesSet(state, newState) {
      state.datesSet = newState;
    },
    updateWindowInnerWidth(state, newState) {
      state.windowInnerWidth = newState;
    },
    updateMobileBreakpoint(state, newState) {
      state.mobileBreakpoint = newState;
    },
    updateResetToCalendarView(state, newState) {
      state.resetToCalendarView = newState;
    },
    updateCalendarView(state, newState) {
      state.calendarView = newState;
    },
    updateLocked(state, newState) {
      state.locked = newState;
      if (state.locked === false) {
        state.showSpinner = false;
      }
    },
    updateShowSpinner(state, newState) {
      state.showSpinner = newState;
    },
    updateNewTypeCount(state, newCount) {
      state.newTypeCount = newCount;
    },
    updateNewArticleTypeCount(state, newCount) {
      state.newArticleTypeCount = newCount;
    },
    updateNewGroupOneCount(state, newCount) {
      state.newGroupOneCount = newCount;
    },
    updateNewGroupTwoCount(state, newCount) {
      state.newGroupTwoCount = newCount;
    },
    updateNewResourceTypeCount(state, newCount) {
      state.newResourceTypeCount = newCount;
    },
    updateNewIssueCount(state, newCount) {
      state.newIssueCount = newCount;
    },
    updateNewCampaignCount(state, newCount) {
      state.newCampaignCount = newCount;
    },
    updateNewRoleCount(state, newCount) {
      state.newRoleCount = newCount;
    },
    updateNewYearCount(state, newCount) {
      state.newYearCount = newCount;
    },
    updateNewStateCount(state, newCount) {
      state.newStateCount = newCount;
    },
    updateNewNEATodayCount(state, newCount) {
      state.newNEATodayCount = newCount;
    },
    updateNewProfessionalPracticeCount(state, newCount) {
      state.newProfessionalPracticeCount = newCount;
    },
    updateNewFormatCount(state, newCount) {
      state.newFormatCount = newCount;
    },
    updateNewAcademicSubjectCount(state, newCount) {
      state.newAcademicSubjectCount = newCount;
    },
    updateNewGradeLevelCount(state, newCount) {
      state.newGradeLevelCount = newCount;
    },

    updateNewThemeCount(state, newCount) {
      state.newThemeCount = newCount;
    },
    updateNewReadingLevelCount(state, newCount) {
      state.newReadingLevelCount = newCount;
    },
    updateNewGenreCount(state, newCount) {
      state.newGenreCount = newCount;
    },

    updateNewActionTypeCount(state, newCount) {
      state.newActionTypeCount = newCount;
    },
    updateNewCongressCount(state, newCount) {
      state.newCongressCount = newCount;
    },
    updateNewPositionCount(state, newCount) {
      state.newPositionCount = newCount;
    },
    updateNewChamberCount(state, newCount) {
      state.newChamberCount = newCount;
    },
    updateNewQuickActionCount(state, newCount) {
      state.newQuickActionCount = newCount;
    },
    updateNewFederalLegislationIssueCount(state, newCount) {
      state.newFederalLegislationIssueCount = newCount;
    },
    updateNewEventTypeCount(state, newCount) {
      state.newEventTypeCount = newCount;
    },
    updateNewRegionCount(state, newCount) {
      state.newRegionCount = newCount;
    },
    updateNewShowPastEventsCount(state, newCount) {
      state.newShowPastEventsCount = newCount;
    },

    updateNewBusinessItemTypeCount(state, newCount) {
      state.newBusinessItemTypeCount = newCount;
    },
    updateNewOutcomeCount(state, newCount) {
      state.newOutcomeCount = newCount;
    },
    updateNewStrategicObjectiveCount(state, newCount) {
      state.newStrategicObjectiveCount = newCount;
    },

    updateNewNEATodaySectionCount(state, newCount) {
      state.newNEATodaySectionCount = newCount;
    },
    updateRaYear(state, year) {
      state.raYear = year;
    },

    updateSearchTerm(state, newTerm) {
      state.searchTerm = newTerm;
    },
    updateAutocompleteTerm(state, newTerm) {
      state.autocompleteTerm = newTerm;
    },
    updateCurrentPage(state, newState) {
      state.currentPage = newState;
    },
    updateInitial(state, newState) {
      state.initial = newState;
    },
    updateFullResponse(state, newResponse) {
      state.fullResponse = newResponse;
    },
    updateAutocompleteResultsItems(state, newItems) {
      state.autocompleteResultsItems = newItems;
    },
    updateAutocompleteResultsData(state, newData) {
      state.autocompleteResultsData = newData;
    },
    updateResultsItems(state, newItems) {
      state.resultsItems = newItems;
    },
    updateResultsData(state, newData) {
      state.resultsData = newData;
    },
    updateCalendarResultsItems(state, newItems) {
      state.calendarResultsItems = newItems;
    },
    updateActiveFilters(state, newFilters) {
      state.activeFilters = newFilters;
    },
    updateAllTypeFilters(state, newFilters) {
      state.allTypeFilters = newFilters;
    },
    updateAllGroupOneFilters(state, newFilters) {
      state.allGroupOneFilters = newFilters;
    },
    updateAllGroupTwoFilters(state, newFilters) {
      state.allGroupTwoFilters = newFilters;
    },
    updateAllIssueFilters(state, newFilters) {
      state.allIssueFilters = newFilters;
    },
    updateAllArticleTypeFilters(state, newFilters) {
      state.allArticleTypeFilters = newFilters;
    },
    updateAllResourceTypeFilters(state, newFilters) {
      state.allResourceTypeFilters = newFilters;
    },
    updateAllCampaignFilters(state, newFilters) {
      state.allCampaignFilters = newFilters;
    },
    updateAllRoleFilters(state, newFilters) {
      state.allRoleFilters = newFilters;
    },
    updateAllYearFilters(state, newFilters) {
      state.allYearFilters = newFilters;
    },
    updateAllStateFilters(state, newFilters) {
      state.allStateFilters = newFilters;
    },
    updateAllNEATodayFilters(state, newFilters) {
      state.allNEATodayFilters = newFilters;
    },
    updateAllProfessionalPracticeFilters(state, newFilters) {
      state.allProfessionalPracticeFilters = newFilters;
    },
    updateAllFormatFilters(state, newFilters) {
      state.allFormatFilters = newFilters;
    },
    updateAllAcademicSubjectFilters(state, newFilters) {
      state.allAcademicSubjectFilters = newFilters;
    },
    updateAllGradeLevelFilters(state, newFilters) {
      state.allGradeLevelFilters = newFilters;
    },

    updateAllThemeFilters(state, newFilters) {
      state.allThemeFilters = newFilters;
    },
    updateAllReadingLevelFilters(state, newFilters) {
      state.allReadingLevelFilters = newFilters;
    },
    updateAllGenreFilters(state, newFilters) {
      state.allGenreFilters = newFilters;
    },

    updateAllActionTypeFilters(state, newFilters) {
      state.allActionTypeFilters = newFilters;
    },
    updateAllCongressFilters(state, newFilters) {
      state.allCongressFilters = newFilters;
    },
    updateAllPositionFilters(state, newFilters) {
      state.allPositionFilters = newFilters;
    },
    updateAllChamberFilters(state, newFilters) {
      state.allChamberFilters = newFilters;
    },
    updateAllQuickActionFilters(state, newFilters) {
      state.allQuickActionFilters = newFilters;
    },
    updateAllFederalLegislationIssueFilters(state, newFilters) {
      state.allFederalLegislationIssueFilters = newFilters;
    },
    updateAllEventTypeFilters(state, newFilters) {
      state.allEventTypeFilters = newFilters;
    },
    updateAllRegionFilters(state, newFilters) {
      state.allRegionFilters = newFilters;
    },
    updateAllShowPastEventsFilters(state, newFilters) {
      state.allShowPastEventsFilters = newFilters;
    },

    updateAllBusinessItemTypeFilters(state, newFilters) {
      state.allBusinessItemTypeFilters = newFilters;
    },
    updateAllOutcomeFilters(state, newFilters) {
      state.allOutcomeFilters = newFilters;
    },
    updateAllStrategicObjectiveFilters(state, newFilters) {
      state.allStrategicObjectiveFilters = newFilters;
    },

    updateAllNEATodaySectionFilters(state, newFilters) {
      state.allNEATodaySectionFilters = newFilters;
    },

    updatePerPage(state, newPerPage) {
      state.perPage = newPerPage;
    },
    updateFacets(state, newFacets) {
      state.facets = newFacets;
    },
    updateOpenDropdown(state, newDropdown) {
      state.openDropdown = newDropdown;
    },
    updateIsAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    updateNextUrl(state, nextUrl) {
      state.nextUrl = nextUrl;
    },
  },
  actions: {
    // query ({ commit, state, dispatch }, data) {
    //
    // },
  },
})
